const topics = [
    {
        "key": "topics.resource_mapping",
        "string": "Resource, potential mapping"
    },
    {
        "key": "topics.conflicts",
        "string": "Conflicts of use mapping"
    },
    {
        "key": "topics.governance",
        "string": "Governance and policies"
    },
    {
        "key": "topics.market",
        "string": "Market study"
    },
    {
        "key": "topics.rdtechnical",
        "string": "R&D technical concepts"
    },
    {
        "key": "topics.rdgeoscience",
        "string": "R&D geoscience"
    },
    {
        "key": "topics.rdeconomics",
        "string": "R&D economics"
    },
    {
        "key": "topics.casestudy",
        "string": "Case study"
    },
    {
        "key": "topics.guideline",
        "string": "Technical guideline"
    }
]

export default topics



// WEBPACK FOOTER //
// ./src/i18n/en/topics/_topics.js